<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Update Customer</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid p-0 py-2">
      @if (sharedService.isRoles([enums.BOSS, enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF, enums.STAFF])) {
        <div class="px-2">
          @if (!sharedService.isStaff()) {
            <div class="form-floating mb-3">
              <input type="text" required class="form-control" [(ngModel)]="updatingCustomer.Name" name="customerName" placeholder="Name" />
              <label for="customerName" class="form-label">Name</label>
            </div>
            <div class="form-floating mb-3">
              <input type="text" required class="form-control" [(ngModel)]="updatingCustomer.ICNumber" name="icNumber" (keypress)="sharedService.isNumberKey($event)" placeholder="IC Number" />
              <label for="icNumber" class="form-label">IC Number</label>
              @if (sharedService.checkIfICValid(updatingCustomer.ICNumber) == false) {
                <span class="text-danger">IC number format incorrect</span>
              }
            </div>
            <div class="form-floating mb-3">
              <input type="text" required class="form-control" [(ngModel)]="updatingCustomer.ContactNo" name="contactNo" (keypress)="sharedService.isNumberKey($event)" placeholder="Phone Number" />
              <label for="contactNo" class="form-label">Phone Number</label>
            </div>
            <div class="form-floating mb-3">
              <select id="gender" name="gender" class="form-control" [(ngModel)]="updatingCustomer.Gender" required>
                <option value="0" disabled selected hidden>SELECT A GENDER</option>
                @for (gender of enums.genderOptions; track gender) {
                  <option [value]="gender">{{ gender }}</option>
                }
              </select>
              <label for="gender">Gender</label>
            </div>
            <div class="form-floating mb-3">
              <select id="race" name="race" class="form-control" [(ngModel)]="updatingCustomer.Race" required>
                <option value="0" disabled selected hidden>SELECT A RACE</option>
                @for (race of enums.raceOptions; track race) {
                  <option [value]="race">{{ race }}</option>
                }
              </select>
              <label for="race">Race</label>
            </div>
          }

          <div class="form-floating mb-3">
            <textarea class="form-control" cols="30" style="height: 100px" required [(ngModel)]="updatingCustomer.Address" name="address" placeholder="Address"></textarea>
            <label for="address" class="form-label">Address</label>
          </div>
          <div class="form-floating mb-3">
            <textarea class="form-control" cols="30" style="height: 100px" [(ngModel)]="updatingCustomer.Address2" name="address2" placeholder="Address 2"></textarea>
            <label for="address2" class="form-label">Address 2</label>
          </div>
          <div class="form-floating mb-3">
            <input type="text" class="form-control" [(ngModel)]="updatingCustomer.OtherID" name="otherId" placeholder="Other Id" />
            <label for="otherId" class="form-label">Other Id</label>
          </div>
        </div>
        <hr class="my-4" />
      }

      @if (sharedService.isRoles([enums.BOSS, enums.ADMIN])) {
        <div class="px-2">
          <mat-form-field subscriptSizing="dynamic" class="mb-3 w-100">
            <mat-label>Date of Birth</mat-label>
            <input matInput [matDatepicker]="dobDatepicker" name="dobDatepicker" [(ngModel)]="updatingCustomer.DOB" [max]="sharedService.getTodayDate()" onkeydown="return false;" />
            <mat-datepicker-toggle matSuffix [for]="dobDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #dobDatepicker name="dob"></mat-datepicker>
          </mat-form-field>
          <button class="btn btn-warning" (click)="updateDOB()">Update DOB</button>
        </div>
        <hr class="my-4" />
        <div class="px-2">
          <mat-form-field subscriptSizing="dynamic" class="mb-3 w-100">
            <mat-label>EPF Settlement Date</mat-label>
            <input matInput [matDatepicker]="epfDatepicker" name="epfDatepicker" [(ngModel)]="updatingEPF.Date" [min]="sharedService.getTodayDate()" [max]="sharedService.addBufferDayToEPFMaxDate(30)" />
            <mat-datepicker-toggle matSuffix [for]="epfDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #epfDatepicker name="dob"></mat-datepicker>
          </mat-form-field>
          <div class="form-floating mb-3">
            <input type="number" class="form-control" [(ngModel)]="updatingEPF.Amount" name="epfAmount" (keypress)="sharedService.isNumberKey($event)" (paste)="onAmountPaste($event)" placeholder="EPF Amount (RM)" />
            <label for="epfAmount" class="form-label">EPF Amount (RM)</label>
          </div>
          <button class="btn btn-warning" (click)="updateEPFDetails()">Update EPF Details</button>
        </div>
      }
    </div>
  </div>

  @if (sharedService.isRoles([enums.BOSS, enums.BRANCH_MANAGER, enums.BOOKKEEPING_STAFF, enums.STAFF])) {
    <div class="modal-footer">
      <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disableSubmit">Update Customer</button>
      <button class="btn btn-outline-danger" type="button" data-dismiss="modal" onclick="form.reset()">Clear</button>
    </div>
  }
</form>
